jQuery(function () {
    var instructionBook = $('.instruction-book-overlay');
    $('.js-open-instruction-book').on('click', function () {
        openDialog();
    });
    instructionBook.on('click', '.js-instruction-book-tab', function () {
        var tabToUpdate = $(this);
        updateInstructionBook(tabToUpdate);
    });
    $(window).on('load', function () {
        var query = window.location.search;
        if (query.toLowerCase().indexOf('intro=true') >= 0) {
            window.history.replaceState({}, document.title, window.location.href.replace('intro=True', '').replace('intro=true', ''));
            openDialog();
        }
    });
    instructionBook.on('click', '.js-instruction-book-close-btn', function () {
        $(this).closest('.instruction-book-overlay').fadeOut('450', function () {
            $(this).closest('.instruction-book-overlay').removeClass('visible');
            $('body').removeClass('instruction-book-open');
        });
    });
    instructionBook.on('click', '.js-instruction-book-next-btn', function () {
        var activeTab = $('.instruction-book__tab').filter('.active');
        var tabToUpdate = activeTab.next();
        updateInstructionBook(tabToUpdate);
    });
    instructionBook.on('click', '.js-instruction-book-prev-btn', function () {
        var activeTab = $('.instruction-book__tab').filter('.active');
        var tabToUpdate = activeTab.prev();
        updateInstructionBook(tabToUpdate);
    });
    instructionBook.on('click', '.js-instruction-book-tabs-dropdown-btn', function () {
        $(this).next('.instruction-book-dropdown').slideToggle().toggleClass('visible');
        $(this).toggleClass('expanded');
    });
    function openDialog() {
        $('.instruction-book-overlay').load('/instruktionsbok');
        $('body').addClass('instruction-book-open').removeClass('prevent-mobile-scroll');
        $('.js-navigation-hamburger').removeClass('is-active');
        $('.navigation-bar').removeClass('mobile-menu-open');
        $('.instruction-book-overlay').addClass('visible');
        $('.instruction-book-overlay').removeAttr('style');
    }
    function updateInstructionBook(tab) {
        updateActiveTab(tab);
        updateArrows(tab);
        updateMobileHeader(tab);
    }
    function updateActiveTab(tab) {
        var tabId = tab.attr('href');
        $('.instruction-book__tab').removeClass('active');
        $('.instruction-book__tab-content').removeClass('active');
        tab.addClass('active');
        $(tabId).addClass('active');
    }
    function updateArrows(tab) {
        var nextTab = tab.next();
        var prevTab = tab.prev();
        if (nextTab.length > 0) {
            $('.js-instruction-book-next-btn').addClass('visible');
        }
        else {
            $('.js-instruction-book-next-btn').removeClass('visible');
        }
        if (prevTab.length > 0) {
            $('.js-instruction-book-prev-btn').addClass('visible');
        }
        else {
            $('.js-instruction-book-prev-btn').removeClass('visible');
        }
    }
    function updateMobileHeader(tab) {
        var tabChildren = tab.children().clone();
        var dropdown = $('.js-instruction-book-tabs-dropdown-btn').next('.instruction-book__tabs-dropdown');
        $('.js-instruction-book-tabs-dropdown-btn').empty().append(tabChildren);
        if (dropdown.hasClass('visible')) {
            dropdown.slideUp().removeClass('visible');
            $('.js-instruction-book-tabs-dropdown-btn').removeClass('expanded');
        }
    }
});
